import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    padding: 7,
    borderRadius: 50,
  },
});
